var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"center-image m-b-10",attrs:{"src":require("@/assets/btn_google_signin_light_normal_web@2x.png")},on:{"click":_vm.googleOauth}})}
var staticRenderFns = []

export { render, staticRenderFns }